import { render } from "./cellAth.vue?vue&type=template&id=15353308"
import script from "./cellAth.vue?vue&type=script&lang=js"
export * from "./cellAth.vue?vue&type=script&lang=js"

import exportComponent from "D:\\inspemblelcsgn\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__